<template>
  <!-- header -->
  <router-view/>
  <!-- footer -->
</template>

<style lang="scss">

// @import './assets/css/bootstrap.min.css';
@import './assets/css/style.css';
@import './assets/css/animate.css';
@import './assets/css/all.css';
@import url('https://fonts.googleapis.com/css2?family=Cookie&display=swap');

// @import './assets/css/custome-user.css';
// @import './assets/css/ordermenu.css';
</style>
